export const statuses = [
    { label: 'Suggested', value: 'S' },
    { label: 'Draft', value: 'D' },
    { label: 'Approved', value: 'A' },
    { label: 'Pilot', value: 'P' },
    { label: 'empty', value: '' },
    { label: 'Operational', value: 'O' },


]; // Example list of options for dropdown

export const shortlist_indicators =[
    { label: 'Manual', value: 'M' },
      { label: 'empty', value: '' },
    { label: 'Automated', value: 'A' },

]


export const health_system_functions =[
    { label: 'Care delivery', value: 'Care delivery' },
    { label: 'Demographics', value: 'Demographics' },
    { label: 'Financing', value: 'Financing' },
    { label: 'Governance', value: 'Governance' },
    { label:'Health Outcomes', value:'Health Outcomes'},
    { label:'Resources', value:'Resources'},
    { label: 'empty', value: '' },

    { label:'Two categories: Resources and Care delivery', value:'Two categories: Resources and Care delivery'},

]



export const domains = [
    { label: 'Secundary Healthcare',value:'Secundary Healthcare' },
    { label: 'Home/telecare and Active life', value: 'Home/telecare and Active life' },
    { label: 'Primary Care', value: 'Primary Care' },
    { label: 'Public health indicators', value:'Public health indicators' },
    { label: 'NCDs and Mental Health',value:'NCDs and Mental Health' },
    { label: 'Palliative and Long term care', value: 'Palliative and Long term care' },
    { label: 'empty', value: '' },

    { label: 'All domains', value: 'All domains' },
];

export const type_of_healthcare_providers_D1_D7list = [

    { label: 'D1',value:'D1' },
    { label: 'D2', value: 'D2' },
    { label: 'D3', value: 'D3' },
    { label: 'D4', value:'D4' },
    { label: 'D5',value:'D5' },
    { label: 'D6', value: 'D6' },
    { label: 'empty', value: '' },
    { label: 'D7', value: 'D7' }
  

]

export const dimensions = [
    { label: 'safety', value: 'safety' },
    { label: 'empty', value: '' },

    { label: 'effectiveness', value: 'effectiveness' }


]; // Example list of options for dropdown

export const classification_dimension = [
    { label: 'A_Inputs_Workforce (Quantity/Training; capacity building)', value: 'A' },
    { label: 'B_Inputs_Social determinants of health and care', value: 'B' },
    { label: 'C_Process_Equity (gender balance, minorities, migrants)', value: 'C' },
    { label: 'D_Process_Access', value: 'D' },
    { label: 'H_Process_Patient Experience', value: 'H' },
    { label: 'E_Process_Cost containing and efficiency', value: 'E' },
    { label: 'F_Process_Green and sustainability', value: 'F' },
    { label: 'G_Process_Digital and healthcare transformation', value: 'G' },
    { label: 'H_Outputs_Patient Satisfaction', value: 'H' },
    { label: 'I_Outputs_Health Gains', value: 'I' }
];


export const cross_Cutting_Dimensions_Inputs_Process_Outputlist = [
     { label: 'Inputs', value: 'Inputs' },
    { label: 'Process', value: 'Process' },
    { label: 'Outputs', value: 'Outputs' },
    { label: 'Cost containing and efficiency', value: 'Cost containing and efficiency' },
];

export const category_of_indicators = [
    { label: '', value: 'safety' },
    { label: 'empty', value: '' },

    { label: 'effectiveness', value: 'effectiveness' }


]; // Example list of options for dropdown

export const QoCOfficeReportlist = [
    { label: 'Efficiency', value: 'Efficiency' },
    { label: 'Timely Access', value: 'Timely Access' },
    { label: 'Care Delivery — Sub-category: Timely access', value: 'Care Delivery — Sub-category: Timely access' },
    { label: 'Care Delivery — Sub-category: Efficiency', value: 'Care Delivery — Sub-category: Efficiency' },

    { label: 'Equity', value: 'Equity' },
    { label: 'Effectiveness', value: 'Effectiveness' },
    { label: 'empty', value: '' },
    { label: 'Safety', value: 'Safety' }
];

export const prioritylist = [
    { label: '1st priority', value: '1' },
    { label: '2nd priority', value: '2' },
    { label: 'empty', value: '' },
    { label: '3rd priority', value: '3' }
];


// export const data_collection_list = [
//     { label: 'AUTOMATED', value: 'AUTOMATED' },
//     { label: 'MANUAL', value: 'MANUAL' },
//     { label: 'empty', value: '' },
//     { label: 'AUTOMATED NEW / INNOVATIVE', value: 'AUTOMATED NEW / INNOVATIVE' }
// ];

export const legal_Organizational_Requirements_list = [
    { label: 'No need', value: '1' },
    { label: 'Legal base exist but needs to be "operationalized" via a guideline/regulation by ODYPI/Other org', value: '2' },
    { label: 'New Legal base is needed (MoH order)', value: '3' },
    { label: 'empty', value: '' },
    { label: 'New Legal base is needed (Law)', value: '4' }
];

export const selected_indicator_list = [
    { label: 'YES', value: 'YES' },
    { label: 'NO', value: 'NO' },
    { label: 'empty', value: '' },

    { label: 'MAYBE', value: 'MAYBE' }
];


export const piloting_list = [
    { label: 'YES', value: 'YES' },
    { label: 'NO', value: 'NO' },
    { label: 'empty', value: '' },
    { label: 'N/A', value: 'N/A' }
];

export const pilot_outcome_list = [
    { label: 'MAINTAIN AS IS', value: '1' },
    { label: 'MAINTAIN but adjust', value: '2' },
    { label: 'empty', value: '' },
    { label: 'SUSPEND', value: '3' }
];

export const forPilotlist = [
    { label: 'No', value: '0' },
    { label: 'Yes', value: '1' },
    { label: 'empty', value: '' },
    { label: 'WeWillTry', value: 'T' }
   
];

// export const PublicationsOptionslist =[
//     { label: 'SomePubHs', value: 'SomePubHs' },
//     { label: 'IdikaSWHs', value: 'IdikaSWHs' },
//     { label: 'ALLPubHs', value: 'ALLPrivHs' },
//     { label: 'ALLPub_ProvHs', value: 'ALLPub_ProvHs' },
//     { label: 'keno', value: '' },
//     { label: 'PHC', value:'PHC'}
// ];

export const dpoList = [
    {label: "1" , value: "1" },
    {label: "empty" , value: '' },
]

export const idikaList = [
    {label: "1" , value: "1" },
    {label: "empty" , value: '' },
]

export const keteknyList = [
    {label: "1" , value: "1" },
    {label: "empty" , value: '' },
]

export const eoppyList = [
    {label: "1" , value: "1" },
    {label: "empty" , value: '' },
]

export const odipyList = [
    {label: "1" , value: "1" },
    {label: "empty" , value: '' },
]

export const mohList = [
    {label: "1" , value: "1" },
    {label: "empty" , value: '' },
]


